<nav class="navbar bg-black">
  <a class="nav-logo" [routerLink]="['/']" routerLinkActive="router-link-active">
    <img src="assets/images/nav-logo.png" alt="" />
  </a>

  <!-- middle Content -->
  <ul class="navbar-nav d-flex flex-row align-items-center justify-content-center">
    <li class="nav-item active">
      <a
        class="nav-link mx-1"
        [routerLink]="['/rewards']"
        routerLinkActive="router-link-active"
        attr.aria-label="{{ 'nav.rewards.screenreader' | translate: { fgbdefault: 'Move to rewards page' } }}"
        >{{ 'nav.rewards' | translate }}</a
      >
    </li>
    <ng-container *notInProductCode="productCode.Partners">
      <li class="nav-item active">
        <a
          class="nav-link mx-1"
          [routerLink]="['/badges']"
          routerLinkActive="router-link-active"
          attr.aria-label="{{ 'nav.challenges.screenreader' | translate: { fgbdefault: 'Move to challenges page' } }}"
          >{{ 'nav.challenges' | translate }}</a
        >
      </li>
      <li class="nav-item active">
        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.games'">
          <a
            class="nav-link mx-1"
            [routerLink]="['/games']"
            routerLinkActive="router-link-active"
            attr.aria-label="{{ 'nav.games.screenreader' | translate: { fgbdefault: 'Move to games page' } }}"
            >{{ 'nav.games' | translate }}</a
          >
        </ng-container>
      </li>
      <li class="nav-item active">
        <a
          class="nav-link mx-1"
          [routerLink]="['/earn']"
          routerLinkActive="router-link-active"
          attr.aria-label="{{ 'nav.earn.screenreader' | translate: { fgbdefault: 'Move to earn points page' } }}"
          >{{ 'nav.earn' | translate }}</a
        >
      </li>
      <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.partners'">
        <ng-container *inProductCode="productCode.ShouldSeePartners">
          <li class="nav-item active">
            <a
              class="nav-link mx-1"
              [routerLink]="['/partners']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.partners.screenreader' | translate: { fgbdefault: 'Move to partners page' } }}"
              >{{ 'nav.partners' | translate }}</a
            >
          </li>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *inProductCode="[productCode.Partners]">
      <li class="nav-item active">
        <a
          class="nav-link mx-1"
          [routerLink]="['/rewards/events']"
          routerLinkActive="router-link-active"
          attr.aria-label="{{ 'nav.events.screenreader' | translate: { fgbdefault: 'Move to events page' } }}"
          >{{ 'nav.events' | translate }}</a
        >
      </li>
    </ng-container>
  </ul>

  <!-- Right Side Content -->
  <!-- points-container -->
  <div class="right-side-navbar d-flex flex-row align-items-center justify-content-center">
    <div class="balance font-size-14 bg-glass mx-0">
      <div class="d-flex align-items-center justify-content-center gap-2" *ngIf="loyaltyPointsCard$">
        <span class="icons material-icons text-white" aria-hidden="true">loyalty</span>
        <span class="fw-bold text-white"
          >{{ loyaltyPointsCard$ | async | number: '1.0-0' }} {{ 'fgbcl.currency.pts' | translate }}</span
        >
      </div>
    </div>

    <!--Notifications-->
    <fgb-notification-button></fgb-notification-button>

    <button
      class="nav-link btn d-flex align-items-center mx-0 px-0 justify-content-end"
      (click)="isNavOpen = !isNavOpen"
      id="namedropdown"
      attr.aria-label="{{ 'nav.account.menu.screenreader' | translate }}"
      tabindex="-1"
      focusTab
    >
      <i class="material-symbols-outlined text-white">menu</i>
    </button>
  </div>
</nav>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4">
    <!-- <fgbcl-loading [size]="'small'"></fgbcl-loading> -->
  </div>
</ng-template>

<div class="right-nav-menu-overlay" *ngIf="isNavOpen" [@rightMenuOverlayAnimation]></div>
<div class="right-nav-menu" [@rightNavAnimation]="isNavOpen ? 'open' : 'close'" [ngClass]="{ open: isNavOpen }">
  <div class="d-flex flex-column h-100">
    <!-- Close Button -->
    <button type="button" class="btn-close position-absolute" (click)="isNavOpen = false" aria-label="Close"></button>

    <!-- Club Logo -->
    <div class="d-flex align-items-center justify-content-start brand-logo">
      <img class="brand" src="assets/images/nav-logo.png" draggable="false" />
    </div>

    <div class="modal-content d-flex flex-column">
      <div class="fw-bold text-uppercase font-size-18 font-page-heading" *ngIf="memberDetails$ | async as memberDetails">
        {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
      </div>
      <div class="account-num-header font-sie-14 d-flex flex-row align-items-center" *ngIf="card$ | async as memberCard">
        <span class="font-size-14">{{ memberCard.ProductCode }} </span>
        <div class="px-1">-</div>
        <span class="font-size-14">{{ memberCard.ExternalRefNumber }}</span>
      </div>
    </div>

    <div class="right-nav-menu-list">
      <!-- Nav Buttons -->
      <div class="upper-right-nav-menu-list d-flex flex-column">
        <a
          class="right-nav-menu-item"
          data-bs-dismiss="offcanvas"
          [routerLink]="['/account']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.profile' | translate }}</div>
        </a>

        <a
          class="right-nav-menu-item"
          data-bs-dismiss="offcanvas"
          [routerLink]="['/rewards/wallet']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.wallet' | translate }}</div>
        </a>

        <a class="right-nav-menu-item" data-bs-dismiss="offcanvas" target="_blank" [href]="'ticket.account' | translate">
          <div class="nav-text">{{ 'nav.orioles.ticket.account' | translate }}</div>
        </a>

        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.partners'">
          <ng-container *inProductCode="productCode.ShouldSeePartners"
            ><a
              class="right-nav-menu-item"
              data-bs-dismiss="offcanvas"
              [routerLink]="['/pointsmanagement']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="nav-text">{{ 'nav.points.transfer' | translate }}</div>
            </a></ng-container
          >
        </ng-container>

        <a class="right-nav-menu-item" data-bs-dismiss="offcanvas" target="_blank" [href]="'privacy.policy.link' | translate">
          <div class="nav-text">{{ 'nav.privacy.policy' | translate }}</div>
        </a>

        <ng-container *notInProductCode="[productCode.Partners]">
          <a
            class="right-nav-menu-item"
            data-bs-dismiss="offcanvas"
            [routerLink]="['/terms']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text">{{ 'nav.terms' | translate }}</div>
          </a>
        </ng-container>

        <a
          class="right-nav-menu-item"
          data-bs-dismiss="offcanvas"
          [routerLink]="['/faq']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.faq' | translate }}</div>
        </a>

        <ng-container *inProductCode="[productCode.Partners]">
          <a
            class="right-nav-menu-item"
            data-bs-dismiss="offcanvas"
            [routerLink]="['/terms']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text">{{ 'nav.terms' | translate }}</div>
          </a>
        </ng-container>

        <a
          class="right-nav-menu-item"
          data-bs-dismiss="offcanvas"
          [routerLink]="['/contact']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-text">{{ 'nav.contact.us' | translate }}</div>
        </a>

        <a class="right-nav-menu-item" data-bs-dismiss="offcanvas" target="_blank" [href]="'terms.of.use.link' | translate">
          <div class="nav-text">{{ 'nav.terms.of.use' | translate }}</div>
        </a>
      </div>

      <div class="bottom-right-nav-container">
        <span class="font-size-14 m-0 text-black">{{ 'mobile.nav.copy.right' | translate }}</span>

        <a class="log-out font-size-14 fw-bold d-flex flex-row align-items-center" data-bs-dismiss="offcanvas" (click)="logout()">
          <span class="material-symbols-outlined text-error"> logout </span>
          <div class="nav-text fw-bold text-error">{{ 'nav.log.out' | translate }}</div>
        </a>
      </div>
    </div>
  </div>
</div>
